import { useEffect, useState } from "react";
import { useParams } from "react-router";
//import { OperationContext } from "../CreateOperation";
import { useStorageCraftStore } from "../store/StorageStore";
import { ColumnItem } from "../../../common/models/table";
import { Loader } from "../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { HttpStatusCode } from "axios";
import { ManifestoService } from "../../operations/core/_request";
import StorageCraftDetail from "./forms/StorageCraftDetail";
import CustomModal from "../../../common/components/Modal/CustomModal";
import CustomerRemovalForm from "./forms/CustomerRemovalForm";
import { StorageService } from "../core/_request";
import { AiOutlineFilePdf } from "react-icons/ai";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { CiInboxOut } from "react-icons/ci";

interface StorageCraftListProps {
  storageType: string;
}

const StorageCraftList = ({ storageType }: StorageCraftListProps) => {
  // const { initialValue, refreshData } = useContext(OperationContext);

  const [isShowForm, setIsShowForm] = useState<boolean>(false);

  const {
    list: craftList,
    setList: setCraftList,
    pageState,
    actioned,
    setActioned,
    setPageState,
    totalItems,
    resetPageState,
  } = useStorageCraftStore();

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState({});

  const [downloadingId, setDownloadingId] = useState<string | null>(null);
  const idPdf = (craftList as any)[0]?.["@id"]?.split("/").pop();

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      // isCanSort: true,
    },

    {
      key: "craftType",
      title: "Type",
      dataIndex: "craftType",
      show: true,
      // isCanSort: true,
      nestedKey: "craftType.id",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
      // isCanSort: true,
    },
  ];

  useEffect(() => {
    fetchRequest();
  }, [pageState]);

  const fetchRequest = (params?: any) => {
    getMovement("api/craft_loads", {
      ...pageState,
      "storageLoads.storage": id,
      "storageLoads.storageLoadState": ["IN", "RETURNED"],

      ...params,
    });
  };

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await ManifestoService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setCraftList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onFinishAction = () => {
    setIsOpenModal(false);
    fetchRequest({ page: 1 });
    setPageState({
      ...pageState,
      page: 1,
    });
  };

  const handleOpenModal = () => {
    if (!isOpenModal) {
      getStorageLoad({
        ...pageState,
        storageLoadState: "IN",
        storage: id,
        // "uniqueIdentifierLoad": craftList[0]?.batchNumber
      });
    }
    setIsOpenModal((prev: boolean) => !prev);
  };

  const getStorageLoad = async (params: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageLoadList(params);
      if (res.status === HttpStatusCode.Ok) setModalData(res?.data?.member[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadClick = async (action: any) => {
    const rowData = action.row;
    try {
      const idPdf = rowData?.["@id"]
        ? rowData["@id"].split("/").pop()
        : rowData?.id;
      if (!idPdf) {
        console.error("Impossible de trouver l'ID pour cette ligne :", action);
        return;
      }
      const fileName = rowData?.batchNumber || "Rapport";
      setDownloadingId(idPdf);
      await downloadPDF(`/api/craft_loads/${idPdf}/EIR`, `craft_${fileName}_EIR.pdf`);
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div>
      <div>
        <Loader isLoading={isLoading} />
        <LFTableV3
          columns={cols}
          data={craftList}
          params={pageState}
          onAction={(record: any, actionType: ActionsKey) => {
            if (actionType === "read") {
              setActioned({ action: actionType, data: record });
              setIsShowForm(true);
            }
          }}
          isCanShow={() => true}
          onSearch={(search: any) => {
            setPageState(search);
          }}
          onSort={(sort: any) => {
            setPageState(sort);
          }}
          onResetSearch={() => {
            resetPageState();
          }}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={(e: any) => setPageState(e)}
          otherActions={[
            /* (row) => (
              <div className="" onClick={handleOpenModal}>
                <CiInboxOut size={17} title="Enlèvement client" />
              </div>
            ), */
            (rowAction) => {
              const rowData = rowAction.row;
              const rowId = rowData?.["@id"]?.split("/").pop() || rowData?.id;
              return (
                <>
                  { storageType === "OpenStorage" && (
                  <>
                  {(!rowData?.imported) ? (
                    <div>
                      {downloadingId === rowId ? (
                        <Spin
                          indicator={<LoadingOutlined spin />}
                          size="small"
                        />
                      ) : (
                        <AiOutlineFilePdf
                          title="Générer EIR"
                          onClick={() => handleDownloadClick(rowAction)}
                        />
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  </>                  
                )}
                </>
              );
            },
          ]}
        />
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : "Nouvau"
          }
          width={"75%"}
        >
          <StorageCraftDetail
            {...{
              initialValue: actioned?.data,
              type: actioned?.action,
            }}
          />
        </CustomDrawer>
      ) : (
        ""
      )}

      {/* Modal section */}
      {isOpenModal && (
        <CustomModal
          isOpen={isOpenModal}
          hanldeCloseModal={handleOpenModal}
          title="Enlèvement client"
        >
          <CustomerRemovalForm
            onFinish={onFinishAction}
            initialValue={modalData}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default StorageCraftList;
